import {createApp} from 'vue'
import AppFinBestaetigung from './AppFinBestaetigung.vue'
import store from '../store'

createApp(AppFinBestaetigung)
    .use(store)
    .mount('#gui_finBestaetigung');

